import React from 'react';
import { Box, Container } from '@mui/joy';
import { AdminServices } from '../../components/congregation/AdminServices';

/**
 * Admin Services Management Page
 * Allows admins to manage all services across the congregation
 */
export default function CongregationServicesPage() {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box>
        <AdminServices />
      </Box>
    </Container>
  );
}
